module.exports = __webpack_public_path__ + "static/img/5-role.a06d97d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/5-role.png
// module id = jcbu
// module chunks = 1